import React from 'react';
import { Calendar, Clock, Tag } from 'lucide-react';
import { blogData } from '../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const BlogSection = () => {
  return (
    <section id="blog" className="py-24 bg-black relative">
      <div className="absolute top-0 left-1/2 w-96 h-96 bg-green-500/5 rounded-full blur-3xl transform -translate-x-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono mb-4">
              {'<'} Blog {'/>'}
            </h2>
            <p className="text-gray-400 font-mono">Pensamientos, ideas y experiencias sobre tecnología</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {blogData.map((post, index) => (
              <Card
                key={post.id}
                className="bg-gray-900/50 border-green-500/20 hover:border-green-400 transition-all duration-300 overflow-hidden group cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative overflow-hidden h-48">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                  <Badge className="absolute top-4 right-4 bg-green-500 text-black font-mono">
                    {post.category}
                  </Badge>
                </div>

                <CardHeader>
                  <CardTitle className="text-xl text-green-400 font-mono group-hover:text-green-300 transition-colors">
                    {post.title}
                  </CardTitle>
                </CardHeader>

                <CardContent>
                  <CardDescription className="text-gray-300 mb-4">
                    {post.excerpt}
                  </CardDescription>

                  <div className="flex items-center justify-between text-sm text-gray-500 font-mono">
                    <div className="flex items-center gap-2">
                      <Calendar size={14} />
                      <span>{new Date(post.date).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock size={14} />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-12 text-center">
            <button className="px-8 py-3 border-2 border-green-500 text-green-400 font-mono font-bold rounded-lg hover:bg-green-500/10 transition-all">
              VER TODOS LOS ARTÍCULOS
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;